import React from "react";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
const Option = (props) => {
  const { hideCheckbox, isMulti } = props.selectProps; // 🔹 access from selectProps
  return (
    <div>
      <components.Option {...props}>
        {isMulti && !hideCheckbox && ( // only show checkboxes in multi mode
          <>
            <input
              style={{ cursor: "pointer" }}
              type="checkbox"
              checked={props.isSelected}
              onChange={() => null}
            />
            &nbsp;
          </>
        )}
        <label style={{ cursor: "pointer" }}>{props.label}</label>
      </components.Option>
    </div>
  );
};
export const MultiSelect = ({
  options,
  optionSelected,
  setOptionSelected,
  onSelectOption,
  type,
  isMulti = true,
  hideCheckbox = false,
}) => {
  return (
    <span
      style={{ width: "100%" }}
      className="d-inline-block"
      data-toggle="popover"
      data-trigger="focus"
      data-content="Please selecet account(s)"
    >
      <ReactSelect
        options={options}
        isMulti={isMulti}
        closeMenuOnSelect={!isMulti} // 🔹 close immediately if single select
        hideSelectedOptions={false}
        components={{ Option }}
        onChange={(e) => {
          if (setOptionSelected) {
            setOptionSelected(e);
          }
          if (onSelectOption) {
            onSelectOption(type, e);
          }
        }}
        allowSelectAll={isMulti} // 🔹 only allow select all in multi mode
        value={optionSelected}
        hideCheckbox={hideCheckbox}
        isClearable={!isMulti} // 🔹 allow clearing in single select
      />
    </span>
  );
};